var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandartsListItems',{attrs:{"routeName":"StandartsModule","items":_vm.list,"fields":_vm.standartFields,"caption":_vm.caption,"loading":_vm.loading,"error":_vm.error,"paramName":"mid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }